module.exports = __webpack_public_path__ + "img/ww-mob-1.a02aa16f.svg";